
<div class="myAccount">
<div class="container">
<div class="">
<!-- Filter Panel end -->
<div class="">
<!-- Page Title -->
<div class="row"> 
                    <!-- Profile Detail Left Panel start here -->
                    <profile-detail></profile-detail>
                    <!-- Profile Detail Left Panel end here -->
                    <div class="col-xs-12 col-sm-12 col-md-9 mdy-width-77">
                        <div class="bdr">
                            <div class="cat-list">

                                <div class="cat-sec-ttl">
                                    <div *ngIf="userProfileType?.reg_profile == 'Other' || userProfileType?.reg_profile == null || userProfileType?.reg_profile == ''">
                                        MANAGE TEAM INFORMATION
                                    </div>
                                    <div *ngIf="userProfileType?.reg_profile == 'Broker'">
                                        <div><a routerLink="/dashboard/brokerbusinesslisting">Business Listing</a></div>
                                        {{BusinessAdvDetailsdata.advmt_headline}}
                                    </div>
                                </div>

                                <!-- search keywords start -->
                                <div class="colorstrip">
                                    <ul>
                                        <li><a routerLink="/dashboard/businessConfidential/{{profile_str}}">Confidential Info</a></li>
                                        <li><a routerLink="/dashboard/businessAdvDetails/{{profile_str}}">Advert Details</a></li>
                                        <li><a routerLink="/dashboard/businessInformation/{{profile_str}}">Business Info</a></li>
                                        <li><a routerLink="/dashboard/businessFinanceDetails/{{profile_str}}">Financial Details</a></li>
                                        <li class="selected"><a routerLink="/dashboard/businessTeamDetails/{{profile_str}}">Team Details</a></li>
                                        <li><a routerLink="/dashboard/businessLocationDetails/{{profile_str}}">Headquarters</a></li>
                                        <li><a routerLink="/dashboard/businessRequirement/{{profile_str}}">Requirements</a></li>
                                        <li><a routerLink="/dashboard/businessAttachment/{{profile_str}}">Attachments</a></li>
                                    </ul>
                                </div>
                                <!-- search keywords end -->

                            </div>
                            <div class="margin-20">
                                <div class="row form-sec">
                                    <div class="col-xs-12 col-sm-12 col-md-12">
                                        <form #businessForm="ngForm" (ngSubmit)="businessMyAccountSubmit(businessForm)"
                                              class="form-horizontal" name="businessForm" role="form">

                                            <div class="msg-pnl_sales" *ngIf="businessProfileSuccessError"
                                                 style="margin-bottom:20px; text-align:center;">
                                                {{businessProfileSuccessError}}
                                            </div>
                                            <div class="msg-pnl_sales" *ngIf="businessProfileFailError"
                                                 style="margin-bottom:20px; text-align:center;">
                                                {{businessProfileFailError}}
                                            </div>

                                            <div class="sec-slide-effect" style="position: relative; z-index:1;">
                                                <!-- <div class="row">
                                                    <div class="col-xs-12"><div class="frm-sec-ttl">Director / CEO information</div></div>
                                                </div> -->
                                                <div class="row form-group has-feedback">
                                                    <label class="col-xs-12 col-sm-6 col-md-4 control-label">Name<span
                                                            class="star">*</span> <span>:</span></label>
                                                    <div class="col-xs-12 col-sm-6 col-md-7">
                                                        <div class="input-group">
                                                            <input type="text" class="form-control" name="director_name"
                                                                   [ngModel]="BusinessTeamDetailsdata?.teamInfo.director_name"
                                                                   placeholder="Enter Your Name"
                                                                   data-error="Please fill out this field." required>
                                                            <span class="glyphicon form-control-feedback"
                                                                  aria-hidden="true"></span>
                                                        </div>
                                                        <div class="help-block with-errors"></div>
                                                    </div>
                                                </div>
                                                <div class="row form-group has-feedback">
                                                    <label class="col-xs-12 col-sm-6 col-md-4 control-label">Email
                                                        ID<span class="star">*</span> <span>:</span></label>
                                                    <div class="col-xs-12 col-sm-6 col-md-7">
                                                        <div class="input-group">
                                                            <input type="text" class="form-control"
                                                                   name="director_email"
                                                                   [ngModel]="BusinessTeamDetailsdata?.teamInfo.director_email"
                                                                   placeholder="Enter Your Email"
                                                                   data-error="Please fill out this field." required>
                                                            <span class="glyphicon form-control-feedback"
                                                                  aria-hidden="true"></span>
                                                        </div>
                                                        <div class="help-block with-errors"></div>
                                                    </div>
                                                </div>

                                                <div class="row form-group has-feedback">
                                                    <label class="col-xs-12 col-sm-6 col-md-4 control-label">Designation<span
                                                            class="star">*</span> <span>:</span></label>
                                                    <div class="col-xs-12 col-sm-6 col-md-7">
                                                        <div class="input-group">
                                                            <select class="form-control" name="director_designation"
                                                                    [ngModel]="BusinessTeamDetailsdata?.teamInfo.director_designation"
                                                                    data-error="Please fill out this field." required>
                                                                <option *ngFor="let designation of designationinf"
                                                                        [value]="designation.id"
                                                                        [selected]="designation.id == 'BusinessTeamDetailsdata.teamInfo.director_designation'">
                                                                    {{designation.name}}
                                                                </option>
                                                            </select>
                                                            <span class="glyphicon form-control-feedback"
                                                                  aria-hidden="true"></span>
                                                        </div>
                                                        <div class="help-block with-errors"></div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="sec-slide-effect">
                                                <div class="row">
                                                    <div class="col-xs-12">
                                                        <div class="frm-sec-ttl mytc">Management Team Information</div>
                                                    </div>
                                                </div>
                                                <div class="form-group txt-center">
                                                    <div class="sec-hide">
                                                        <div class="row">
                                                         
                                                            
                                                                
                                                                            <label class="col-xs-12 col-sm-4 col-md-4 control-label">Name<span
                                                                                    class="star">*</span></label>
                                                                      
                                                                 
                                                                            <label class="col-xs-12 col-sm-4 col-md-4 control-label">Designation<span
                                                                                    class="star">*</span></label>
                                                                       
                                                                
                                                                            <label class="col-xs-12 col-sm-4 col-md-4 control-label">Email
                                                                                ID<span class="star">*</span></label>
                                                                       
                                                                
                                                          
                                                        </div>
                                                    </div>

                                                    <!-- Clone Box -->
                                                    <div class="clonebox box_container" id="team_detail">
                                                        <div class="entry"
                                                             *ngFor="let mgtInf of BusinessTeamDetailsdata?.mgtTeamInf; let i=index;" [id]="'clone' + i">

                            <div class="">
                                <div class="row">
                             
                                            <div class="form-group col-xs-12 col-sm-4 col-md-4 has-feedback">
                                                <div class="input-group">
                                                    <input type="text" name="name"
                                                           value="{{mgtInf.name}}"
                                                           class="form-control"
                                                           placeholder="Enter Name"
                                                           data-error="Please fill out this field."
                                                           required>
                                                    <span class="glyphicon form-control-feedback"
                                                          aria-hidden="true"></span>
                                                </div>
                                                <div class="help-block with-errors"></div>
                                       
                                    </div>
                              
                                            <div class="form-group col-xs-12 col-sm-4 col-md-4 has-feedback">
                                                <div class="input-group">
                                                    <input type="text"
                                                           name="designation"
                                                           value="{{mgtInf.designation}}"
                                                           class="form-control"
                                                           placeholder="Enter Designation"
                                                           data-error="Please fill out this field."
                                                           required>
                                                    <span class="glyphicon form-control-feedback"
                                                          aria-hidden="true"></span>
                                                </div>
                                                <div class="help-block with-errors"></div>
                                            </div>
                                       
                              
                                            <div class="form-group col-xs-12 col-sm-4 col-md-4 has-feedback">
                                                <div class="input-group">
                                                    <input type="text" name="email"
                                                           value="{{mgtInf.email}}"
                                                           class="form-control"
                                                           placeholder="Enter Email ID"
                                                           data-error="Please fill out this field."
                                                           required>
                                                    <span class="glyphicon form-control-feedback"
                                                          aria-hidden="true"></span>
                                                </div>
                                                <div class="help-block with-errors"></div>
                                            </div>
                                       
                                </div>
                            </div>

                                                            <div class="myicona">
                                                                <a *ngIf="i===0" id="add0" [routerLink]=""
                                                                   class="addbox cloneadd" onclick="cloneDiv('#team_detail')">
                                                                    <i class="fa fa-plus" aria-hidden="true"></i></a>
                                                                <a [id]="'rem'+ i" [routerLink]=""
                                                                   onClick="removeFormdiv(this.id);" class="removebox" [style.display]="( i>0)? 'table':'none'">
                                                                    <i class="fa fa-times" aria-hidden="true"></i></a>
                                                            </div>

                                                        </div>
                                                    </div>
                                                    <!-- /Clone Box -->

                                                </div>
                                            </div>
                                            <div class="sec-slide-effect txt-cen">
                                                <div class="submitfrm">
                                                    <button type="submit" class="btn btn-default btn-blue">SUBMIT
                                                    </button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- End Start Body Part -->
